<template>
  <div class="NewDetail">
    <div class="shortcut">
        <div class="w">
            <div class="fl">
                <ul>
                    <li class="home">
                        <a href="javascript:void(0);"  @click="returnBack">
                            <img src="../assets/images/brnav_home.png" alt="">
                            首页 >
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" @click="blackLast">{{firMenu.Name}}&nbsp;></a>
                    </li>
                    <li>
                        <a href="#">{{curMenu.Name}} </a>
                    </li>
                </ul>

            </div>

        </div>

    </div>
    <!-- 大主体 -->
    <div class="bg_bd">
        <div class="w">
            <div class="main">
                <p class="main_top">
                    {{info.Title}}
                </p>
                <p class="main_date">
                  <span v-if="info.ReleaseDate">日期：{{info.ReleaseTime}}</span>
                  <span v-else>日期：{{info.dateTime}}</span>
                  <span>作者：{{info.Auther}}</span>
                  <span>点击次数：{{info.ClickedCount}}次</span>
                </p>
                <div class="main_z html-wrap" v-html="info.HtmlContent">
                </div>
                <div class="newsn">
                    <div class="newsn_header">
                        相关新闻
                    </div>
                    <div class="newsn-alk">
                        <ul>
                            <li v-for="(items,index) in relatedNews" v-if="(IndexVal-1)<=index && index <= (IndexVal+1)">
                              <div v-if="items.IsWeixin">
                                <a  :href="items.URL" target="_blank">{{items.Title}}</a>
                              </div>
                              <div v-else>
                                <a href="javascript:void(0);" @click="goDetail(items)">{{items.Title}}</a>
                              </div>
                            </li>
                        </ul>
                    </div>
                    <div class="closeBtn">
                        <span @click="CloseBtn">关闭</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import * as utils from '../utils.js'
import * as api from '../api/api.js'
export default {
  data () {
    return {
      curMenu: '',
      firMenu: '',
      htmlCont: '',
      loading: false,
      info: {},
      imgUrl: 'http://service.jinlingholdings.com/Api/File/getImage/',
      relatedNews:[],
      IndexVal:'',
      ScreenWidth:''
    }
  },
  watch: {
    '$route': function (val,oldVal) {
      this.init()
      console.log(val)
      console.log(oldVal)
      this.ScreenWidth=window.innerWidth
    }
  },
  created () {
    this.init ()

  },
  methods: {
    CloseBtn(){
      if(this.ScreenWidth <500){
        this.$router.go(-1)
        window.close();
      }else {
        window.location.href="about:blank";
        window.close();
      }
    },
    // 返回首页
    returnBack(){
      this.$router.push({path: '/'})
    },
    // 返回上一级
    blackLast(){
      this.$router.go(-1)
    },
    init: function () {
      var storage = utils.storage.get('jinLin_menu')
      if (storage && storage.data) {
        storage.data.forEach((vv) => {
          if (vv.Key === this.$route.params.fkey) {
            var _this = this
            this.firMenu = vv
            vv.subMenu.forEach((ss) => {
              if (ss.Key === this.$route.params.key) {
                _this.curMenu = ss
              }
            })
          }
        })
      }
      this.getContent()
    },
    getContent: function () {
      let param = {
        Id: this.$route.params.newsId
      }
      this.loading = true
      api.getNewsDetail(param).then((res) => {
        this.loading = false
        if (res.Status === 100) {
          this.info = res.Data
          var srcHtml = res.Data.HtmlContent
          srcHtml = srcHtml.replace(/{jinlinhost}/g, api.host)
          srcHtml.replace(/36.156.158.238:23456/g, api.host)
          this.info.HtmlContent = srcHtml
          this.$set(this.info,'dateTime',this.$moment(res.Data.CreateDt).format('LL'))
          this.$set(this.info,'ReleaseTime',this.$moment(res.Data.ReleaseDate).format('LL'))

          // 相关新闻
          var Params = {
            igid: res.Data.Ass_Category_Id,
            Page: 1,
            PageSize: 1000
          }
          api.getNewsList(Params).then(resTwo =>{
            if(resTwo.Status === 100){
              resTwo.Data.DataList.forEach((dd,index)=>{
                if(dd.Id!==res.Data.Id){
                  this.relatedNews.push(dd)
                  if (dd.Thumbnai) {
                    dd.imgUrl = this.imgUrl + dd.Thumbnai
                  }
                  if(dd.IsWeixin){
                    dd.URL = JSON.parse(dd.HtmlContent).url
                  }
                  dd.DateTime = this.$moment(dd.CreateDt).format('LL')
                }else {
                  this.IndexVal = index
                }
              })
            }
          })
        }
      })
    },
    getBtn: function (item) {
      this.$router.push({name: 'news', params: {fkey: this.$route.params.fkey, key: item.Key}})
    },
    goDetail: function (item) {
      this.$router.push({name: 'newsDetail', params: {fkey: this.$route.params.fkey, key: this.$route.params.key, newsId: item.Id}})
    }
  }
}
</script>

<style>
@import url("../assets/NewsDetail.css");
</style>



// WEBPACK FOOTER //
// src/components/newsDetail.vue